var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLavalLogoRenverse(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "110px",
    height: "39px",
    viewBox: "0 0 110 39",
    style: {
      enableBackground: "new 0 0 110 39"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M45,14.7l-14.6,0L15.6,0L0,0.1l0,15.6l23.2,23.1l30.1-0.1l0-15.6L45,14.7z M30.2,15.5l14,0l0,14l-14,0 L30.2,15.5z M15.6,1.1l13.8,13.8l0,14.1L15.6,15.2L15.6,1.1z M0.8,0.8l14,0l0,14l-14,0L0.8,0.8z M23.6,37.9L1.1,15.6l13.8,0 l14.8,14.8l14.5,0l7.6,7.6L23.6,37.9z M52.6,37.5L45,30l0-14.2l7.6,7.6L52.6,37.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M108.1,32.4l-3.4,0l0-7.7l-1.8-1.8l-3.8,0l0,6.4l-3.1-3c-0.6-0.6-1.4-0.9-2.2-0.9c-1,0-1.9,0.5-2.5,1.2 L90,25.2l-4.5,0l-0.9,2.7l-2.7-2.7l-4.5,0l1.3,3.8l-2.9-2.8c-0.6-0.6-1.4-0.9-2.2-0.9c-1.4,0-2.6,0.9-3,2.2l-2.1,6.1l-1.1-1.1 l-3.4,0l0-7.7l-1.8-1.8l-3.8,0l0,13.3l2.4,2.3l12.1,0l1.1-3.1l1.1,0l1.1,3.1l6,0l-0.9-2.6c1.2,1.2,2.5,3,4.4,2.6 c1-0.2,1.9-1,2.4-1.9l1.9,1.8l3,0l1.1-3.1l1.1,0l1.1,3.1l13.9,0l0-4.1L108.1,32.4z M67.1,36l-8.1,0l0-12.3l2.7,0l0,9.6l5.3,0 L67.1,36z M76,36l-2.4-6.7l-0.8,2.5l0.9,0l0.5,1.5l-2,0L71.3,36l-2.8,0l2.9-8.3c0.3-0.9,1.2-1.6,2.3-1.6c1,0,1.9,0.7,2.3,1.6 l2.9,8.3L76,36z M86,34.3c-0.3,0.9-1.2,1.6-2.3,1.6c-1,0-1.9-0.7-2.3-1.6l-2.9-8.3l2.8,0l2.4,6.7L86,26l2.8,0L86,34.3z M96.1,35.9 l-1-2.7l-2,0l0.5-1.5l0.9,0l-0.9-2.4l-2.3,6.7l-2.8,0l2.9-8.3c0.3-0.9,1.2-1.6,2.3-1.6c1,0,1.9,0.7,2.3,1.6l2.9,8.3L96.1,35.9z  M107.8,35.9l-8.1,0l0-12.3l2.7,0l0,9.6l5.3,0L107.8,35.9z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLavalLogoRenverse);
export default __webpack_public_path__ + "static/media/laval-logo-renverse.d1e9c5539e4731bba837786820937a89.svg";
export { ForwardRef as ReactComponent };